import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#003082', // A
          'primary-darken1': '#1b3259', // R
          'primary-lighten1': '#bdd5ff', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#ffcd00', // B
          'secondary-darken1': '#e0b055', // D
          secondaryBtnText: '#424242', // B'
          headerBack: '#140B8C', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#003082', // H
          topSecondaryBtn: '#ffcd00', // I
          topSecondaryBtnText: '#424242', // J
          topPrimaryBtn: '#003082', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#003082', // N
          secondaryOutLineBtnText: '#424242', // O
          topBtnUpTextSp: '#003082', // P
          topBtnBackSp: '#FDEEB3', // Q'
          eventHeaderBack: '#003082',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#003082',
          accent: '#003082', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
